























































































































import { Component, Vue } from "vue-property-decorator";
import { BCard, BCardGroup, BCardText, BCardImg } from "bootstrap-vue";
@Component({
  components: {
    BCard,
    BCardGroup,
    BCardText,
    BCardImg
  }
})
export default class SpellingInterractExe extends Vue {}
